var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLaunchpack)?_c('basic-customer-inquiry'):_vm._e(),(_vm.isLaunchpack)?_c('launchpack-customer-inquiry'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }